// true: 前进。false: 后退
var direction = true
var isLoad = true
var index = history.length - 1
var states = [{ key: 'stateId0' }, { key: 'stateId1' }]
var stateId = 2
const originHistory = {}
const parsedHistory = {
  pushState (data, title, url) {
    direction = true
    isLoad = false
    if (!data) {
      data = { key: 'stateId' + stateId++ }
    }
    states = states.slice(0, ++index).concat(data)
    return originHistory.pushState.call(history, data, title, url)
  },
  replaceState (data, title, url) {
    direction = true
    isLoad = false
    if (!data) {
      data = { key: 'stateId' + stateId++ }
    }
    states = states.slice(0, index).concat(data)
    return originHistory.replaceState.call(history, data, title, url)
  }
}

if (!history.state) {
  history.replaceState({ key: 'stateId1' }, null, location.search + location.hash)
}

for (var key in parsedHistory) {
  if (typeof history[key] === 'function') {
    originHistory[key] = history[key]
    history[key] = parsedHistory[key]
  }
}

function findStateIndex (key) {
  for (var i = 0, length = states.length; i < length; i++) {
    if (states[i].key === key) {
      return i
    }
  }
}

window.addEventListener('popstate', (e) => {
  isLoad = false
  if (e.state && e.state.key) {
    var stateIndex = findStateIndex(e.state.key)
    if (stateIndex > index) {
      index++
      direction = true
    } else {
      index--
      direction = false
    }
  }
})

window.addEventListener('beforeunload', function () {
  isLoad = false
  var myHistory = {
    index,
    states,
    stateId
  }
  sessionStorage.setItem('MY_HISTORY', JSON.stringify(myHistory))
})

window.addEventListener('load', function () {
  var myHistory = sessionStorage.getItem('MY_HISTORY')
  if (myHistory) {
    myHistory = JSON.parse(myHistory)
    index = myHistory.index
    states = myHistory.states
    stateId = myHistory.stateId
  }
  isLoad = true
})

export function getDirection () {
  return direction
}

export function getIsLoad () {
  return isLoad
}
